import {booleanAttribute, ChangeDetectionStrategy, Component, input} from "@angular/core"

let nextInstanceId = 0

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-asset-dimension-overlay",
    templateUrl: "./asset-dimension-overlay.component.html",
    styleUrls: ["./asset-dimension-overlay.component.scss"],
    host: {
        "[class.cm-mode-wrap]": "$orientation() === 'wrap'",
    },
})
export class AssetDimensionOverlayComponent {
    readonly $widthLabel = input.required<string>({alias: "widthLabel"})
    readonly $heightLabel = input.required<string>({alias: "heightLabel"})
    readonly $hideLabels = input(false, {alias: "hideLabels", transform: booleanAttribute})
    readonly $orientation = input<"top-left" | "wrap">("top-left", {alias: "orientation"})

    private readonly instanceId = ++nextInstanceId
    readonly arrowLeftId = `cm-arrow-left-${this.instanceId}`
    readonly arrowRightId = `cm-arrow-right-${this.instanceId}`
    readonly arrowTopId = `cm-arrow-top-${this.instanceId}`
    readonly arrowBottomId = `cm-arrow-bottom-${this.instanceId}`
}
